import React from 'react';
import ReactDOM from 'react-dom/client';

import { ConfigProvider } from 'antd';
import enUS from 'antd/es/locale/en_US.js';
import itIT from 'antd/es/locale/it_IT.js';

import App from './App';
import './index.css';
import stringres from './translations/stringres';

const lang = localStorage.getItem('codLingua') || 'it';
stringres.changeLanguage(lang);

function handleLanguageChange() {
    if (lang === 'en') {
        return enUS;
    } else if (lang === 'it') {
        return itIT;
    } else return itIT;
}

const root = ReactDOM.createRoot(document.getElementById('root'));

const colorPrimary = getComputedStyle(document.documentElement).getPropertyValue('--primarycolorcustom');

root.render(
    <React.StrictMode>
        <ConfigProvider
            locale={handleLanguageChange}
            theme={{
                token: {
                    fontFamily: 'Montserrat',
                    colorPrimary: colorPrimary,
                },
            }}
        >
            <App />
        </ConfigProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
